export const GET_TYPE_OPERATION = 'GET_TYPE_OPERATION'
export const GET_TYPE_OPERATION_EXITO = 'GET_TYPE_OPERATION_EXITO'
export const GET_TYPE_OPERATION_ERRROR = 'GET_TYPE_OPERATION_ERROR'
